import { useMutation, useQueryClient } from '@tanstack/react-query';
import { controlKeys } from './controls.key';
import { useApi } from '../useApi';
import { toast } from '../../../components/Toast';

type Options = {
  onMarkVerifiedSuccess?: () => void;
  onMarkVerifiedError?: (error: unknown) => void;
};

export function useMarkPersondataVerified(
  inspectionId: string,
  options?: Options
) {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const markVerified = async (data: { controlId: string }) => {
    const api = await getApi();
    const res = await api.controlsMarkPersondataVerified(data.controlId);
    return res.data;
  };

  const onSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: controlKeys.findOne(inspectionId),
    });
    toast.success('Persondata markerad som verifierad');
    options?.onMarkVerifiedSuccess?.();
  };

  const onError = (error: unknown) => {
    toast.error('Kunde inte markera Persondata som verifierad');
    options?.onMarkVerifiedError?.(error);
  };

  const mutation = useMutation(markVerified, {
    onSuccess,
    onError,
  });

  return mutation;
}
